export enum DeviceCheckSolutions 
{
    Undefined = 0,
    PiceaOne = 1,
    PiceaMobile = 2,
    WebBased = 3
}
